import { render, staticRenderFns } from "./menuBox.vue?vue&type=template&id=18635d5c&scoped=true&"
import script from "./menuBox.vue?vue&type=script&lang=js&"
export * from "./menuBox.vue?vue&type=script&lang=js&"
import style0 from "./menuBox.vue?vue&type=style&index=0&id=18635d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18635d5c",
  null
  
)

export default component.exports